import Vue from "vue";
import Vuex from "vuex";
import tree from "./module/tree/tree";
import menu from "./modules/menu";
import home from "./modules/home";
import print from "./modules/print";
import modal from "./modules/modal";
import files from "./modules/files";
import paging from "./modules/paging";
import common from "./modules/common";
import validation from "./modules/validation";
import contextMenu from "./modules/contextMenu";
import cooperation from "./modules/cooperation";
import organization from "./modules/organization";

import modals from "./module/common/modal";
import project from "./module/project/project";
import decision from "./module/decision/decision";
import category from "./module/category/category";
import restAction from "./module/common/restAction";
import evdControl from "./module/common/evdControl";
import coworkUtils from "./module/common/coworkUtils";
import shareInfo from "./module/shareInfo/shareInfo";
import assignment from "./module/assignment/assignment";
import chkPw from "./module/common/chkPw";
import introInfo from "./module/common/introInfo";
import okrQrt from "./module/okr/okrQrt";

import noti from "./module/noti/noti";
import todo from "./module/todo/todo";
import mypage from "./module/private/private";
import mySocket from "./module/socket/mySocket";
Vue.use(Vuex);
export const store = new Vuex.Store({
  modules: {
    tree,
    menu,
    home,
    print,
    modal,
    files,
    paging,
    common,
    validation,
    contextMenu,
    cooperation,
    organization,
    modals,
    restAction,
    evdControl,
    coworkUtils,
    project,
    decision,
    category,
    shareInfo,
    assignment,
    chkPw,
    noti,
    todo,
    mypage,
    introInfo,
    okrQrt,
    mySocket
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/js/store/store.js